import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueAxios from "vue-axios";
import axios from "axios";
import "vuetify/dist/vuetify.min.css";
import "./assets/styles/styles.scss";
import "./router/permission";
// import "./api/httpClient";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
import "@/utils/filters";
import "font-awesome/css/font-awesome.min.css";
import interceptor from "../src/helpers/interceptor";
// import "../src/assets/main.scss";

interceptor();
Vue.config.productionTip = false;

// Global event bus
Vue.prototype.$eventHub = new Vue();

Vue.use(VueAxios, axios);
Vue.use(VueToast, {
  position: "top",
  duration: 3000,
  dismissible: true,
  queue: true
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
